import { ApolloClient, InMemoryCache, HttpLink } from "@apollo/client";

const client = new ApolloClient({
  link: new HttpLink({
    uri: `${process.env.GATSBY_APP_BACKEND_SERVER}/graphql`, // replace with your API endpoint
    // headers: { Authorization: `Bearer ${process.env.API_TOKEN}` }, // if needed
    headers: {
      brokeroverride: "DIRECTACCESS"
    }
  }),
  cache: new InMemoryCache(),
});

export default client;
